import { render, staticRenderFns } from "./RenewIncident.vue?vue&type=template&id=47cbff8b&scoped=true&"
import script from "./RenewIncident.vue?vue&type=script&lang=js&"
export * from "./RenewIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbff8b",
  null
  
)

export default component.exports